















import { routeHelper } from '../../utils/routeHelper';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';

@Component({ components: { CommonDialog } })
export default class MaintenunceSelectDialog extends Vue {
  setting() {
    routeHelper(this, 'TeacherSettingPage');
  }
  passwordChange() {
    routeHelper(this, 'TeacherPasswordChangePage');
  }
  public async show() {
    (this.$refs['MaintenunceSelectDialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['MaintenunceSelectDialog'] as CommonDialog).hide();
  }
}
